import { Trash, PlusCircle } from "phosphor-react";
import React from "react";
import { useMemo } from "react";
import { convertIntegerToMoney } from "src/modules/helpers";
import {X} from "phosphor-react";

import "src/styles/carrinho-item-card.scss";
import { NumberBichoGroup } from "../../rifa/components/layout/numberBichoGroup";

function CarrinhoItemCard({
  apagaAposta,
  reusaAposta,
  title,
  numeros,
  subtotal,
  apostaId,
  leagues = [],
  teams = [],
  index,
  premio,
  enableSide,
  tipoJogo,
}) {
  const valorPremioMaximo = useMemo(() => {
    const prize = (teams || [])
      .concat(leagues || [])
      .reduce(
        (sum, item) =>
          sum > item.objTipoJogo.numValorPagoJogo
            ? sum
            : item.objTipoJogo.numValorPagoJogo,
        0
      );

    return convertIntegerToMoney(
      (subtotal / (leagues.length + teams.length)) * prize
    );
  }, [leagues, teams, subtotal]);

  
  const isGroup = typeof tipoJogo != "undefined" && (tipoJogo.tnyNumeroMax === 25 && tipoJogo.tnyNumeroMin === 1);
  const isCombined = typeof tipoJogo != "undefined" && (!!tipoJogo.tnyTamanhoMax && !!tipoJogo.tnyTamanhoMin && (tipoJogo.tnyTamanhoMax != tipoJogo.tnyTamanhoMin));

  return (
    <div className="cart-card">
      <div className="cart-card_header">
        <div className="cart-card_index">{index + 1}º</div>
        <div className="cart-card_title_container">
          <p className="cart-card_title">{title}</p>
          {premio && <small>Prêmio(os): {premio}</small>}
        </div>
        <div className="cart-card_subtotal">
          <p>Subtotal: R$ {convertIntegerToMoney(subtotal)}</p>
          <button onClick={() => reusaAposta()}>
            <PlusCircle size={20} color="gray" alt="Repetir números" />
          </button>
          <button onClick={() => apagaAposta(apostaId, subtotal)}>
            <Trash size={20} color="red" alt="Deletar aposta" />
          </button>
        </div>
      </div>
      <div className="cart-card_body">
        <div className="cart-card_content">
          {numeros && numeros.length > 0 && (
            <div className="cart-card_team-list">
                { isGroup
                  ? isCombined
                    ? <NumberBichoGroup isCombined={isCombined} numbers={numeros} separatorChar={tipoJogo.chrSeparador} separatorElement={<X weight="bold" color="var(--primary)"/>} hideCorrespondantNumbers/>
                    : <NumberBichoGroup numbers={numeros} separatorChar={tipoJogo.chrSeparador} separatorElement={<X weight="bold" color="var(--primary)"/>} hideCorrespondantNumbers/>
                  : numeros.map((numero) => <div className="cart-card_number">{numero}</div>)
                }
            </div>
          )}

          {leagues && leagues.length > 0 && (
            <div className="cart-card_team">
              <h4>Ligas</h4>
              <div className="cart-card_team-list isSupertime">
                {leagues.map((league) => (
                  <div className="cart-card_team-tag">
                    {league.vchURLImagem && <img src={league.vchURLImagem} />}
                    <p>{league.nome}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {teams && teams.length > 0 && (
            <div className="cart-card_team">
              <h4>Times</h4>
              <div className="cart-card_team-list isSupertime">
                {teams.map((team) => (
                  <div className="cart-card_team-tag">
                    {team.vchURLImagem && <img src={team.vchURLImagem} />}
                    <p>{team.nome}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {enableSide && (
          <div className="cart-card_side">
            <div>
              <span>Total de Apostas: </span>
              <span>{leagues.length + teams.length} Apostas</span>
            </div>
            <div>
              <span>Prêmio máximo</span>
              <span>{valorPremioMaximo}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CarrinhoItemCard;



// WEBPACK FOOTER //
// ./src/newDesign/components/carrinho-item-card.jsx